<template>
  <main id="content" role="main" class="flex p-5 h-screen">
    <div class="w-full flex items-center">
      <div class="w-full max-w-[700px] mx-auto">
        <div class="font-poppins mb-4">
          <h1 class="text-5xl font-bold">404</h1>
          <p class="text-xl mt-2">Oops! Looks like you followed a bad link. <br> If you think this is a problem with us, please contact <a href="mailto:service@tradierbrokerage.com" class="text-brand-secondary font-normal hover:underline">service@tradierbrokerage.com or call us at 980.272.3880.</a></p>
        </div>
        <a class="button" href="/">Back Home</a>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: '404',
  beforeCreate() {
    this.$router.push('404')
  }
}
</script>
